import type { TMultipleValueType } from './components.type';

export const isTMultipleValue = <TValue extends TMultipleValueType>(
  value: TValue,
  newValue: unknown[],
): newValue is TValue => {
  if (!value.length || !newValue.length) {
    return true;
  }

  return newValue.every((item) => typeof item === typeof value[0]);
};
